import { useEffect, useState, useRef, useCallback } from "react"
import Helpers from "../../../Helpers/Helpers"
import AstrologerCard from "../../components/AstrologerCard"
import { Link, useLocation, useNavigate } from "react-router-dom"
import BannerCarousel from "../../components/BannerCarousel"
import debounce from 'lodash/debounce'
import { LANGUAGE_LABELS, SPECIALIZATION_LABELS } from '../../../constants/labels'

const languageOptions = [ {value:'', label:'All Languages'}, ...Object.entries(LANGUAGE_LABELS).map(([value,label])=>({value,label})) ]
const specializationOptions = [ {value:'', label:'All Specializations'}, ...Object.entries(SPECIALIZATION_LABELS).map(([value,label])=>({value,label})) ]
const sortOptions = [
  { value: '', label: 'Sort by' },
  { value: 'rating', label: 'Rating' },
  { value: 'experience', label: 'Experience' },
  { value: 'price', label: 'Price' },
]

// Sort options
const SORT_OPTIONS = [
  { key: 'experience_high', label: 'Experience : High to Low' },
  { key: 'experience_low', label: 'Experience : Low to High' },
  { key: 'chats_high', label: 'Total chats : High to Low' },
  { key: 'chats_low', label: 'Total chats : Low to High' },
  { key: 'price_high', label: 'Price : High to Low' },
  { key: 'price_low', label: 'Price : Low to High' },
  { key: 'rating_high', label: 'Rating : High to Low' },
  { key: 'rating_low', label: 'Rating : Low to High' }
]

// Side modal filter component
function FilterModal({ show, onClose, filters, setFilters, onApply, onReset }) {
  const [activeTab, setActiveTab] = useState('language')
  const languageEntries = Object.entries(LANGUAGE_LABELS)
  const specializationEntries = Object.entries(SPECIALIZATION_LABELS)
  return (
    <div className={`filter-modal-backdrop${show ? ' show' : ''}`} onClick={onClose}>
      <div className={`filter-modal${show ? ' show' : ''}`} onClick={e => e.stopPropagation()}>
        <div className="filter-modal-header d-flex justify-content-between align-items-center">
          <span className="fw-bold">FILTERS</span>
          <button className="btn btn-link text-dark fs-4 p-0" onClick={onClose}>&times;</button>
        </div>
        <div className="filter-modal-body d-flex">
          <div className="filter-modal-tabs flex-shrink-0">
            <ul className="nav flex-column">
              <li className="nav-item"><button className={`nav-link${activeTab==='language'?' active':''}`} onClick={()=>setActiveTab('language')}>Language</button></li>
              <li className="nav-item"><button className={`nav-link${activeTab==='specialization'?' active':''}`} onClick={()=>setActiveTab('specialization')}>Specialization</button></li>
              {/* Add more tabs here */}
            </ul>
          </div>
          <div className="filter-modal-options flex-grow-1 ps-3">
            {activeTab==='language' && (
              <div>
                {languageEntries.map(([key,label]) => (
                  <div className="form-check mb-2" key={key}>
                    <input className="form-check-input" type="radio" name="language" id={`lang-${key}`} checked={filters.language===key} onChange={()=>setFilters(f=>({...f,language:key}))} />
                    <label className="form-check-label" htmlFor={`lang-${key}`}>{label}</label>
                  </div>
                ))}
              </div>
            )}
            {activeTab==='specialization' && (
              <div>
                {specializationEntries.map(([key,label]) => (
                  <div className="form-check mb-2" key={key}>
                    <input className="form-check-input" type="radio" name="specialization" id={`spec-${key}`} checked={filters.specialization===key} onChange={()=>setFilters(f=>({...f,specialization:key}))} />
                    <label className="form-check-label" htmlFor={`spec-${key}`}>{label}</label>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="filter-modal-footer d-flex justify-content-between align-items-center mt-3">
          <button className="btn btn-link text-danger" onClick={onReset}>Reset</button>
          <button className="btn btn-warning px-4" onClick={onApply}>Apply</button>
        </div>
      </div>
    </div>
  )
}

function SortModal({show, onClose, sortOption, setSortOption}){
  return (
    <div className={`filter-modal-backdrop${show?' show':''}`} onClick={onClose}>
      <div className={`filter-modal show`} onClick={e=>e.stopPropagation()} style={{width:320}}>
        <div className="filter-modal-header d-flex justify-content-between align-items-center">
          <span className="fw-bold">SORT BY</span>
          <button className="btn btn-link text-dark fs-4 p-0" onClick={onClose}>&times;</button>
        </div>
        <div className="filter-modal-body" style={{padding:'10px 20px'}}>
          {SORT_OPTIONS.map(opt=> (
            <div className="form-check mb-2" key={opt.key}>
              <input type="radio" className="form-check-input" id={`sort-${opt.key}`} name="sortby" checked={sortOption===opt.key} onChange={()=>setSortOption(opt.key)} />
              <label className="form-check-label" htmlFor={`sort-${opt.key}`}>{opt.label}</label>
            </div>
          ))}
        </div>
        <div className="filter-modal-footer d-flex justify-content-between align-items-center mt-3">
          <button className="btn btn-link text-danger" onClick={()=>{setSortOption(''); onClose();}}>Reset</button>
          <button className="btn btn-warning px-4" onClick={onClose}>Apply</button>
        </div>
      </div>
    </div>
  )
}

const styles = `
  .search-container {
    display: flex;
    align-items: center;
    border: 1px solid #6c757d; /* Match btn-outline-secondary */
    border-radius: 4px;
    background: #fff;
    overflow: hidden;
    width: 100%;
  }

  .modern-search-input {
    flex: 1;
    padding: 7px 12px; /* Keep consistent with btn padding */
    border: none;
    outline: none;
    font-size: 15px;
  }

  .modern-search-btn {
    color: #6c757d; /* Same icon color as filter/sort */
    background: transparent;
    border: none;
    padding: 6px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modern-search-btn:hover {
    color: #495057;
    background: #f1f1f1;
  }

  @media (max-width: 575.98px) {
    .modern-search-input { padding: 5px 10px; font-size: 13px; }
    .modern-search-btn { padding: 5px 10px; }
  }
`

const AstrologerComponent = ({ title }) => {
    const helpers = Helpers()
    const navigate = useNavigate()
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const pageFromUrl = parseInt(params.get('page'), 10) || 1
    const searchFromUrl = params.get('name') || ''

    const [astrologers, setAstrologers] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState(searchFromUrl)
    const [isSearching, setIsSearching] = useState(false)
    const [selectedLanguage, setSelectedLanguage] = useState('')
    const [selectedSpecialization, setSelectedSpecialization] = useState('')
    const [sortOption, setSortOption] = useState('')
    const [showFilter, setShowFilter] = useState(false)
    const [showSort, setShowSort] = useState(false)
    const [filters, setFilters] = useState({ language: '', specialization: '' })

    // Observer reference to track when we reach the end of the list
    const observer = useRef()

    const fetchData = async (page, searchQuery, resetList = false) => {
        if (loading) return; // Prevent duplicate requests
        setLoading(true);
        try {
            let url = `/astrologer/?page=${page}&limit=5&type=astrologer`
            if (searchQuery) {
                url += `&name=${encodeURIComponent(searchQuery)}`
            }
            const response = await helpers.httpRequest(url, 'GET');

            if (response.status === 'success') {
                setAstrologers(prevAstrologers => {
                    if (resetList) {
                        return response.data;
                    }
                    // Check for duplicates before adding
                    const newData = response.data.filter(astrologer => 
                        !prevAstrologers.some(existing => existing.id === astrologer.id)
                    );
                    return [...prevAstrologers, ...newData];
                });
                setTotalPages(response.totalPages);
                setTotal(response.total);
            }
        } catch (error) {
            console.error('Error fetching Astrologers:', error);
        } finally {
            setLoading(false);
            setIsSearching(false);
        }
    };

    // Debounced search function
    const debouncedSearch = useCallback(
        debounce((searchValue) => {
            setCurrentPage(1)
            const newParams = new URLSearchParams(search)
            if (searchValue) {
                newParams.set('name', searchValue)
            } else {
                newParams.delete('name')
            }
            newParams.set('page', '1')
            navigate(`/astrologer?${newParams.toString()}`)
            fetchData(1, searchValue, true) // true to reset the list
        }, 500),
        []
    )

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value
        setSearchTerm(value)
        setIsSearching(true)
        debouncedSearch(value)
    }

    useEffect(() => {
        if (!isSearching) {
            fetchData(currentPage, searchTerm);
        }
    }, [currentPage]); // Fetch new data when currentPage changes

    const lastElementRef = useCallback(node => {
        if (loading || currentPage >= totalPages) return; // Stop fetching beyond total pages
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                setCurrentPage(prevPage => prevPage + 1);
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, currentPage, totalPages]);

    // Filtering and sorting logic
    const filteredAstrologers = astrologers
      .filter(a => !filters.language || (a.language && a.language.toLowerCase() === filters.language.toLowerCase()))
      .filter(a => !filters.specialization || (a.specialization && a.specialization.toLowerCase() === filters.specialization.toLowerCase()))
      .filter(a => a.name.toLowerCase().includes(searchTerm.toLowerCase()))
      .sort((a, b) => {
        switch(sortOption){
          case 'experience_high': return (b.experience||b.year_of_exp||0) - (a.experience||a.year_of_exp||0);
          case 'experience_low': return (a.experience||a.year_of_exp||0) - (b.experience||b.year_of_exp||0);
          case 'chats_high': return (b.total_chats || b.ratingDetails?.personCount || 0) - (a.total_chats || a.ratingDetails?.personCount || 0);
          case 'chats_low': return (a.total_chats || a.ratingDetails?.personCount || 0) - (b.total_chats || b.ratingDetails?.personCount || 0);
          case 'price_high': return (b.price||b.fees||0) - (a.price||a.fees||0);
          case 'price_low': return (a.price||a.fees||0) - (b.price||b.fees||0);
          case 'rating_high': return (b.rating||0) - (a.rating||0);
          case 'rating_low': return (a.rating||0) - (b.rating||0);
          default: return 0;
        }
      })

    const handleFilterApply = () => {
      setShowFilter(false)
    }
    const handleFilterReset = () => {
      setFilters({ language: '', specialization: '' })
    }

    return (
        <>
            <BannerCarousel section="best_astrologer" />
            <section className="as_shop_wrapper as_padderBottom90 as_padderTop80">
                <div className="container">
                    {/* Responsive filter/search/sort bar */}
                    <div className="d-flex flex-nowrap justify-content-end align-items-center gap-2 mb-3">
                        <div>
                            <button className="btn btn-outline-secondary gradient-hover d-flex align-items-center gap-1" onClick={()=>setShowFilter(true)}>
                                <i className="fas fa-filter"></i> <span className="d-none d-md-inline">Filter</span>
                            </button>
                        </div>
                        <div>
                           <button className="btn btn-outline-secondary gradient-hover d-flex align-items-center gap-1" onClick={()=>setShowSort(true)}>
                             <i className="fas fa-sort-amount-down"></i><span className="d-none d-md-inline"> Sort by</span>
                           </button>
                        </div>
                        <div className="flex-grow-1" style={{minWidth:0}}>
                            <div className="search-container">
                                <input
                                    className="modern-search-input"
                                    placeholder="Search astrologers..."
                                    type="text"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                                <button className="modern-search-btn" type="button">
                                    <i className="fas fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <FilterModal show={showFilter} onClose={()=>setShowFilter(false)} filters={filters} setFilters={setFilters} onApply={handleFilterApply} onReset={handleFilterReset} />
                    <SortModal show={showSort} onClose={()=>setShowSort(false)} sortOption={sortOption} setSortOption={setSortOption} />
                    {/* Astrologer grid */}
                    <div className="row">
                        {filteredAstrologers.length > 0 ? (
                            filteredAstrologers.map((astrologer, index) => (
                                <div
                                    key={astrologer.id}
                                    ref={index === filteredAstrologers.length - 1 ? lastElementRef : null}
                                    className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-3"
                                >
                                    <AstrologerCard astrologer={astrologer} />
                                </div>
                            ))
                        ) : (
                            !loading && (
                                <div className="col-12 text-center">
                                    <h3>No astrologers found</h3>
                                </div>
                            )
                        )}
                    </div>
                    {/* Loader */}
                    {loading && (
                        <div className="col-12 text-center mt-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}

// Add styles to the document
if (typeof document !== 'undefined') {
  // Remove previously appended style tag (if any) to avoid duplicates
  const existing = document.getElementById('astrologer-search-styles');
  if (existing) existing.remove();

  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.id = 'astrologer-search-styles';
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

export default AstrologerComponent
